import { useContext, useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Container from '../../components/Container';
import Header from '../../components/Header';
import GlobalContext from '../../contexts/GlobalContext';
import GlobalContextI from '../../interfaces/GlobalContext';
import getAge from '../../functions/getAge';

const AUTO_RETURN_MS = 4000;

interface ConfirmState {
    firstName?: string;
    lastName?: string;
    stageName?: string;
    age?: number | null;
    value?: number;
}

const safeAge = (dob: any): number | null => {
    if (!dob) return null;
    try {
        const a = getAge(dob as Date);
        return Number.isNaN(a) ? null : a;
    } catch {
        return null;
    }
};

const LimitedCheckInConfirmationPage = () => {
    const { guest } = useContext<GlobalContextI>(GlobalContext);
    const history = useHistory();
    const location = useLocation<ConfirmState | undefined>();
    const state = location.state || {};

    const display = useMemo(() => {
        const first = state.firstName ?? guest?.firstName ?? '';
        const last = state.lastName ?? guest?.lastName ?? '';
        const stage = state.stageName ?? guest?.stageName ?? '';
        const fullName = `${first} ${last}`.trim() || stage || 'Guest';
        const age =
            typeof state.age === 'number' && !Number.isNaN(state.age)
                ? state.age
                : safeAge(guest?.dateOfBirth);
        const value =
            typeof state.value === 'number' ? state.value : 0;
        return { fullName, age, value };
    }, [state, guest]);

    useEffect(() => {
        const t = window.setTimeout(
            () => history.replace('/guests/checkin/limited'),
            AUTO_RETURN_MS
        );
        return () => window.clearTimeout(t);
    }, [history]);

    return (
        <Container containerName={'landing'}>
            <Header
                title={'Checked In'}
                subtitle={'Returning to check-in screen…'}
                bottomBorder={true}
                padding={true}
            />
            <div
                style={{
                    textAlign: 'center',
                    padding: '2rem 1rem',
                    maxWidth: '40rem',
                    margin: '0 auto',
                }}
            >
                <div
                    style={{
                        fontSize: '2.5rem',
                        fontWeight: 700,
                        color: '#22c55e',
                        marginBottom: '1.5rem',
                    }}
                >
                    {display.fullName}
                </div>
                {display.age !== null && (
                    <div
                        style={{
                            fontSize: '1.5rem',
                            marginBottom: '1rem',
                        }}
                    >
                        Age:{' '}
                        <span style={{ fontWeight: 700 }}>{display.age}</span>
                    </div>
                )}
                <div
                    style={{
                        fontSize: '1.75rem',
                        marginBottom: '2rem',
                    }}
                >
                    Facility Fee:{' '}
                    <span style={{ fontWeight: 700, color: '#22c55e' }}>
                        ${display.value}
                    </span>
                </div>
                <button
                    className="green-button margin"
                    onClick={() =>
                        history.replace('/guests/checkin/limited')
                    }
                >
                    Done
                </button>
            </div>
        </Container>
    );
};

export default LimitedCheckInConfirmationPage;
